import type { ReactNode } from 'react';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { useAuth } from '@/contexts/AuthContext';
import styles from './MainLayout.module.css';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps): ReactNode {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleUserClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  const handleLogout = async () => {
    handleClose();
    await logout();
  };

  return (
    <Box component="div" className={styles.root}>
      <AppBar position="sticky" elevation={0}>
        <Toolbar className={styles.toolbar} disableGutters>
          <Typography
            variant="subtitle1"
            component={RouterLink}
            to="/"
            className={styles.logo}
          >
            Книги
          </Typography>
          {user && (
            <>
              <Button
                color="inherit"
                size="small"
                onClick={handleUserClick}
                className={styles.userButton}
                aria-controls={open ? 'user-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                {user.login}
              </Button>
              <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={handleLogout}>Выйти</MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Box component="main" className={styles.main}>
        <Container maxWidth="md">{children}</Container>
      </Box>
      <Box component="footer" className={styles.footer}>
        <Container maxWidth="md">
          <Typography variant="body2" color="text.secondary">
            © Books
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

